export default __webpack_public_path__ + "static/Living-in-STL_1-a7df6fd34dd2ee4765bbf17fb1decafd.jpg";